import { combineReducers } from 'redux';

import { reducer as orders } from './State/orders';
import { reducer as orderTotals } from './State/orderTotals';
import { reducer as pagination } from './State/pagination';
import { reducer as searchTerm } from './State/searchTerms';
import { reducer as fetching } from './State/fetching';
import { reducer as showOrderModal } from './State/showOrderModal';
import { reducer as sorting } from './State/sorting';
import { reducer as filters } from './State/filters';

export default combineReducers({

  orders,
  orderTotals,
  pagination,
  searchTerm,
  fetching,
  showOrderModal,
  sorting,
  filters
  
})
